import { TranslationService } from "@/core/services/TranslationService";

export function formTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.form.formName"),
      key: "formName",
      sortable: true,
      sortingField: "form_name",
    },
    {
      name: TranslationService.translate("common.onTime"),
      key: "onTime",
      sortable: true,
      sortingField: "on_time",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.outsidePeriod"),
      key: "outsidePeriod",
      sortable: true,
      sortingField: "outside_period",
      attrs: {
        class: "vz-dataTable-center",
      },
    },

    {
      name: TranslationService.translate("common.expired"),
      key: "expire",
      sortable: true,
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function formTableFilters() {
  return [
    {
      key: "formIds",
      label: TranslationService.translate("pages.form.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "forms/filter/FORM_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}
export function dashboardLineChartOptions() {
  return {
    colors: ["#4caf50", "#ff9800", "#BF0A30"],
    chart: {
      height: 350,
      type: "area",
      zoom: {
        enabled: false,
      },
      locales: [
        {
          name: "en",
          options: {
            toolbar: {
              exportToSVG: "Export SVG",
              exportToPNG: "Export PNG",
              exportToCSV: "Export CSV",
            },
          },
        },
      ],
      defaultLocale: "en",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: [""],
    },
    yaxis: {
      opposite: false,
    },
    tooltip: {
      x: {},
    },
  };
}
export function dashboardPieChartOptions() {
  return {
    colors: ["#4caf50", "#ff9800", "#BF0A30"],
    chart: {
      width: 380,
      type: "donut",
    },
    labels: [
      TranslationService.translate("common.onTime"),
      TranslationService.translate("common.outsidePeriod"),
      TranslationService.translate("common.expired"),
    ],
    dataLabels: {
      enabled: true,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: false,
              show: true,
              style: {
                fontSize: "200px",
              },
            },
          },
        },
      },
    },
    legend: {
      position: "bottom",
      offsetY: 0,
      offsetX: 0,
      horizontalAlign: "center",
    },
  };
}
